import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';

class Ejecutivo extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'ejecutivo/one', saveUrl: 'ejecutivo/save', backUrl: '/Catalogo/Ejecutivos' },
      new Form([
        Form.Field('text', 'ejecutivo', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'ejecutivo_nombre', 'Nombre', '', [Validators.required], 4),
        Form.Field('select', 'id_sucursal', 'Sucursal', '', [Validators.required], 4),
      ], ['Guardar'], 'Ejecutivo'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  formData = async (form) => {
    var Res = await Http.get('sucursal/all');

    if (!Res.error) {
      const sucursales = Form.FieldOptions(form, 'id_sucursal', Res.data, 'id', 'sucursal_nombre');
      return sucursales;
    }
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Ejecutivo)
